module.exports = __webpack_public_path__ + "static/img/MO@3x.07a040b7.png";